import { apiServiceProxy } from 'v2/services/api-proxy';

import type { ApiServiceProxy } from 'v2/services/api-proxy';

import type { TestResult, Webhook, WebhookHistory, WebhookHistoryFilter } from './interfaces';
import type IPagination from 'interfaces/IPagination';

class WebhookService {
  constructor(private readonly apiService: ApiServiceProxy) {}

  list = () => this.apiService.get<Webhook[]>('/webhook/v2/urls').then((response) => response.data);

  historyList = (id: string, filter?: WebhookHistoryFilter, pagination?: IPagination) => {
    const startDate = filter?.date[0];
    const endDate = filter?.date[1];

    const emailRegex: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const isCustomerEmail = emailRegex.test(filter?.customer);
    const customer = filter?.customer;

    return this.apiService.get<WebhookHistory[]>(`/webhook/v2/history/${id}`, {
      start_date: startDate,
      end_date: endDate,
      client_name: !isCustomerEmail && customer ? customer : undefined,
      client_email: isCustomerEmail && customer ? customer : undefined,
      entity_id: filter?.entityId || undefined,
      content_ids: filter?.product_id,
      per_page: pagination?.per_page,
      page: pagination?.current_page,
      only_sent: 1,
    });
  };

  public validateUrl = (url: string, type: string) => {
    return this.apiService.post<TestResult>('/webhook/v2/test', { url, type });
  };

  public getProducts = () => {
    return this.apiService.get('/webhook/v2/products');
  };

  public createURL = (name: string, product: number, url: string, type: string) => {
    return this.apiService.post('/webhook/v2/urls', { description: name, product_id: product, url, type });
  };

  public editURL = (id: string, name: string, product: number, url: string) => {
    return this.apiService.put(`/webhook/v2/urls/${id}`, { description: name, product_id: product, url });
  };
  public reactive = (id: string) => {
    return this.apiService.put(`/webhook/v2/urls/${id}/reactivate`, {});
  };
  public inactive = (id: string) => {
    return this.apiService.put(`/webhook/v2/urls/${id}/inactive`, {});
  };
  public removeWebhook = (id: string) => {
    return this.apiService.delete(`/webhook/v2/urls/${id}`, {});
  };
}

const webhookService = new WebhookService(apiServiceProxy);
export default webhookService;
